import { useStore } from '@balm-ui';
import { getRouteParams } from '@yiban-shared/utils/get-route-info';
import { isDev } from '@yiban-shared/config';

export default ({ getFormDataWithDefaultParams }) =>
  async function getModelListDataFn(listViewData) {
    const $store = useStore();
    const { model, modelAction, searchForm, keyName, $route } = listViewData;
    const { data } = searchForm;
    const { keyParams } = getRouteParams({ keyName, $route });

    const params = getFormDataWithDefaultParams
      ? await getFormDataWithDefaultParams('list-view', data, {
          actionType: 'list',
          keyParams,
          ...listViewData
        })
      : data;

    isDev && console.info('getModelListDataFn', model, params);

    const result = await $store.$getModel(model, params, {
      apiAction: modelAction || 'list'
    });

    return result;
  };
